import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { GridDetails, GridEvent } from '../../../sample-tracking/tracking-overview/interfaces/grid';

@Component({
    selector: 'shipment-grid',
    template: require('./shipment-grid.component.html'),
    styles: [require('./shipment-grid.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ShipmentGridComponent {
    public isLoadingCompleted = true;

    @Input()
    public gridDetails: GridDetails;

    @Output()
    public onItemClick: EventEmitter<GridEvent> = new EventEmitter<GridEvent>();

    constructor() { }

    public onGridItemClick(event: any) {
        this.onItemClick.next(event);
    }
}